var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97.516,
    height: 127.485,
    viewBox: "0 0 97.516 127.485",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_246",
    "data-name": "Group 246",
    transform: "translate(-3820.766 -212.735)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2488",
    "data-name": "Path 2488",
    d: "M3596.32,530.32v99.768l23.43-12.384,23.765,12.384V530.32Z",
    transform: "translate(250.583 -289.869)",
    fill: "#3f81da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2485",
    "data-name": "Path 2485",
    d: "M3646.541,732.99l8.568-12.255,13.151,6.775,12.853-6.775,8.867,12.255,13.849.7.9,14.745,11.557,8.17-6.177,12.753,6.177,12.852-11.557,7.771-.9,15.044-13.849.5-8.867,11.951-12.853-5.556-13.151,5.556-8.568-11.951-14.472-.5V789.979l-13.3-7.771,6.9-12.852-6.9-12.753,13.3-8.17V733.687Z",
    transform: "translate(202 -508)",
    fill: "#ffbf00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    cx: 29.5,
    cy: 29.5,
    r: 29.5,
    transform: "translate(3841 232)",
    fill: "#ff8b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2489",
    "data-name": "Path 2489",
    d: "M5363.063,1747.97c5.883-4.411,11.456-8.589,17.025-12.771,1.2-.9,2.458-1.863,3.733-.275,1.352,1.68.405,2.854-1.054,3.938q-8.853,6.567-17.626,13.237c-1.687,1.286-3.04,1.3-4.546-.269-2.727-2.844-5.525-5.621-8.356-8.363-1.18-1.144-1.533-2.213-.278-3.477s2.339-.936,3.481.258C5357.9,1742.813,5360.428,1745.308,5363.063,1747.97Z",
    transform: "translate(-1497.322 -1480.243)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2489_-_Outline",
    "data-name": "Path 2489 - Outline",
    d: "M5362.9,1755.538a5.66,5.66,0,0,1-4.109-1.979c-2.448-2.553-5.082-5.189-8.291-8.3a5.343,5.343,0,0,1-1.828-3.669,5.264,5.264,0,0,1,4.872-4.908,5.084,5.084,0,0,1,3.705,1.834c1.7,1.775,3.417,3.5,5.236,5.322l.82.823.668-.5c5.046-3.783,9.812-7.357,14.615-10.964l.027-.02a6.283,6.283,0,0,1,3.73-1.6,4.311,4.311,0,0,1,3.426,1.782,4.75,4.75,0,0,1,1.169,3.647,6,6,0,0,1-2.682,3.864c-6.954,5.158-12.545,9.357-17.6,13.217A6.161,6.161,0,0,1,5362.9,1755.538Z",
    transform: "translate(-1497.322 -1480.243)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal.09ccc44f826abba030a69eb50068c160.svg";
export { ForwardRef as ReactComponent };